import { render } from "./tipsTwo.vue?vue&type=template&id=29dbec0b"
import script from "./tipsTwo.vue?vue&type=script&lang=js"
export * from "./tipsTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__